import React, { useMemo } from "react";
import { POSA_FORMAT } from "@tootsweet/model/lottery/POSAType";
import KC_UIText from "../../../../../designsystem/typography/KC_UIText/KC_UIText";
import { BASE_URL } from "../../../../../utils/constants";
import { POSA_PLACEHOLDER_IMAGE } from "../../../../17_JetpackOnboarding/constants";
import POSACarousel from "./POSACarousel";
import { POSA_FORMAT_DESC } from "../constants";
import getPOSAListForFormat from "../../../../../utils/helpers/getPOSAListForFormat";
import { usePOSATypesSelector } from "../../../../../redux/actions/wheel";
import { useAccountToDisplaySelector } from "../../../../../redux/actions/user";

interface IProps {
  format: POSA_FORMAT;
  hideDescription?: boolean;
  hidePlaceholderTitle?: boolean;
}

export default function POSAItem(props: IProps) {
  const { accountToDisplay } = useAccountToDisplaySelector();
  const posaTypes = usePOSATypesSelector();

  const hasCustomPOSAFeature = useMemo(() => {
    return (
      !accountToDisplay?.saasFeatures || !!accountToDisplay?.saasFeatures?.cp
    );
  }, [accountToDisplay]);

  const posaList = getPOSAListForFormat(
    props.format,
    posaTypes,
    hasCustomPOSAFeature
  );

  if (!posaList.length) {
    return null;
  }

  return (
    <React.Fragment key={`${props.format}-posa-item`}>
      {!props.hideDescription && (
        <KC_UIText
          className="d-block mb-2 mt-2"
          text={POSA_FORMAT_DESC[props.format]}
          weight="reg"
        />
      )}
      <POSACarousel
        format={props.format}
        imgURL={`${BASE_URL}${POSA_PLACEHOLDER_IMAGE[props.format]}`}
        hidePlaceholderTitle={props.hidePlaceholderTitle}
        posaList={posaList}
      />
    </React.Fragment>
  );
}
